import styled,{ css } from 'styled-components';
import Slider from "@mui/material/Slider";

export const MainWrapper = styled.div`
height:100vh;
display:flex;
flex-direction:column;
`
export const HeaderWrapper = styled.div`
background-color:transparent;
background-image: linear-gradient(130deg, rgb(255 160 0) 0%, rgb(0 39 255) 100%);
height:60px;
display:flex;
flex-direction:column;
align-items:center;
`
export const LeftSideBarWrapper = styled.div`
width:80px;
flex-grow: 3
`
export const RightSideBarWrapper = styled.div`
padding:50px 20px;
height:100%;
`
export const ContentBox = styled.div`
display:flex;
height:100%;
`
export const FlexBox = styled.div`
display:flex;
align-items:center;
`
export const ContentWrapper = styled.div`
flex: 1 1 auto;
width: 100%;
display: flex;
justify-content: center;
align-items: center;
overflow-y: auto;
margin-bottom: 10px;
`
export const TextCenter = styled.div`
text-align:center;
`
export const HeaderLeftWrapper = styled.div`
display:flex;
align-items:center;
justify-content:spase-between;
height:100%;
`
export const HeaderRightWrapper = styled.div`
display:flex;
align-items:center;
justify-content:end;
height:100%;
`
export const HeaderMenu = styled.div`
display:flex;
align-items:center;
justify-content:end;
height:100%;
`
export const HeaderMenuItem = styled.div`
padding:7px 15px;
display:flex;
align-items:center;
justify-content:center;
cursor:pointer;
border-radius: 5px;
gap:7px;

 &:hover {
      background-color: rgb(222 220 222 / 33%);
  }
`
export const MenuItemText = styled.div`
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 22px;
color: #FFFFFF;
`
export const HeaderBtnText = styled.div`
font-style: normal;
font-weight: 500;
font-size: 14px;
color: white;
line-height: 22px;
text-wrap: nowrap;
`
export const LeftMenuWrapper = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:start;
width:100%;
padding-top:10px;
`
export const LeftMenuItem = styled.div`
width: 100%;
height: 70px;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
cursor:pointer;
margin-bottom: 6px;
`
export const LeftMenuIcon = styled.img`
width:20px;
`
export const LeftMenuText = styled.div`
font-style: normal;
font-weight: 500;
font-size: 13px;
line-height: 18px;
color: #38485D;
padding:5px 0px;
text-align:center;
user-select:none;
`
export const HelpWrapper = styled.div`
width:100%;
`
export const HelpBox = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:start;
width:100%;
cursor:pointer;
border-width: 0px 1px 1px 0px;
border-style: solid;
border-color: #E2D8D8;
background-color: ${props => props.isActive === true ? "#6EC3CF" : null};
border-radius: ${props => props.isActive === true ? "0px 222px 222px 0px" : null};
`
export const HelpImage = styled.img`
width:40px;
height:40px;
margin-bottom:5px;
`
export const SallyImage = styled.img`
width:60px !important;
height:55px !important;
`

export const HelpText = styled.div`
font-style: normal;
font-weight: 500;
font-size: 11px;
line-height: 18px;
color: ${props => props.isActive === true ? "#fff" : "#38485D"};
`

export const InfoWrapper = styled.div`
background-color:#fff;
padding:10px;
`
export const InfoBox = styled.div`
display:flex;
align-items:center;
justify-content:space-between;
`
export const InfoTitle = styled.div`
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 17px;
color: #000000;
`
export const InfoDetail = styled.div`
font-style: normal;
font-weight: 300;
font-size: 14px;
line-height: 17px;
color: #000000;
`
export const InfoDetailLight = styled.div`
font-style: italic;
font-weight: 100;
font-size: 14px;
line-height: 17px;
`
export const RightSideBarBox = styled.div`
margin:20px 0px;
`
export const RideSideBarTitle = styled.div`
font-family: 'Lora';
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 23px;
color: #38485D;
`
export const SliderImageBox = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
padding:7px;
margin-bottom:10px;
border-radius: 11px;
cursor:pointer !important;
`
export const SliderImage = styled.img`
width:50px;
height:auto;
margin-bottom:5px;
`
export const SliderImageText = styled.div`
font-style: normal;
font-weight: 400;
font-size: 10px;
line-height: 14px;
color: #000000;
text-align:center;
word-break: break-word;
width:70px;
`
export const TemplateDevider = styled.div`
width: 84px;
height: 8px;
background: #67C5FA;
border-radius: 23px 23px 0px 0px;
transform: matrix(1, 0, 0, -1, 0, 0);
margin-bottom:20px;
`
export const CoverImageWrapper = styled.div`
display:flex;
justify-content: space-between;
margin-top:15px;
`
export const DropzoneBox = styled.div`
display:flex;
align-items:center;
justify-content:center;
flex-direction:column;
height: 89px;
width:100%;
border: 1px dashed #8E8F94;
`
export const ImgUplodedBtn = styled.div`
background: #65F48D;
border-radius: 7px;
width:100%;
display:flex;
justify-content:center;
padding:8px 0px;
align-items:center;
padding-left:3px;
margin-top:7px;
`
export const ImgUplodedBtnText = styled.div`
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 17px;
color: #FFFFFF;
`
export const DropzoneText = styled.div`
font-style: normal;
font-weight: 600;
font-size: 9px;
line-height: 11px;
color:#8E8F94;
`
export const DropzoneLink = styled.span`
font-style: normal;
font-weight: 600;
font-size: 9px;
line-height: 11px;
color:#67C5FA;
cursor:pointer;
`
export const CoverImage = styled.div`
width: 97px;
height: 133px;
border: 2px solid #65F48D;
border-radius: 9px;
display:flex;
align-items:center;
justify-content:center;
`
export const SideBarFomrControl = styled.div`
margin-bottom:10px;
`
export const SideBarFomrLabel = styled.div`
font-family: 'Lora';
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 18px;
display: flex;
color: #8E8F94;
margin-bottom:7px;
`

export const SideBarInput = styled.input.attrs({
  type: 'text',
})`
 
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  color: #000000;
  background: #F9FDFF;
  border: 1px dashed #8E8F94;
  border-radius: 6px;
  padding:6px;
  width:90%;
`
export const LayerBox = styled.div`
display:flex;
align-items:center;
justify-content:start;
background: #DEEFFA;
border: 0.3px solid #7E9DB0;
padding:5px;
`
export const LayerInfo = styled.div`
padding-right:10px;
`
export const LayerText = styled.div`
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 15px;
color: #38485D;
`
export const LayerImage = styled.img`
width: 30px;
`
export const LayerEmpty = styled.div`
width: 30px;
`
export const AddTextRSBHeader = styled.div`
display:flex;
align-items:center;
justify-content:start;
border-bottom: 1px solid #444446;
padding-bottom:15px;
`
export const AddTextRSBHeaderText = styled.div`
font-style: normal;
font-weight: 500;
font-size: 17px;
line-height: 22px;
color: #000000;
margin-left:10px;
`
export const AddTextRSBWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
flex-wrap:wrap;
margin-top:10px;
`
export const AddTextRSBItemBox = styled.div`
width:44.3%;
padding:8px;
`
export const AddTextRSBItem = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
border: 1px solid #000;
border-radius: 11px;
padding:5px;
height: 61px;
cursor:pointer;
`
export const AddTextRSBItemHelp = styled.div`
display:flex;
align-items:center;
justify-content:center;
background: #6EC3CF;
border: 1px solid #6EC3CF;
border-radius: 11px;
padding:5px;
height: 61px;
`
export const AddTextRSBItemText = styled.div`
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 20px;
text-align: center;
color: #000000;
margin-top:5px;
`
export const AddTextRSBItemIcon = styled.img`
width:20px !important;
`

export const DisplayCenter = styled.div`
display:flex;
align-items:center;
justify-content:center;
`
export const DisplayBetween = styled.div`
display:flex;
align-items:center;
justify-content:space-between;
margin-top:${props => props.mt ? props.mt : null};
`
export const DisplayStart = styled.div`
display:flex;
align-items:center;
justify-content:start;
margin-top:${props => props.mt ? props.mt : null};
`
export const DisplayEnd = styled.div`
display:flex;
align-items:center;
justify-content:end;
margin-top:${props => props.mt ? props.mt : null};
`
export const ZoomBox = styled.div`
display:flex;
align-items:center;
justify-content:space-evenly;
background: #FFFFFF;
padding:8px 0px;
width:300px;
margin-top:10px;
border: 1px solid #38485D;
border-radius: 44px;
`
export const FontSettingWrapper = styled.div`
padding:12px 18px;
`
export const FontSettingBox = styled.div`
display:flex;
align-items:center;
justify-content:center;
padding-top:10px;
`
export const ZoomIcon = styled.div`
cursor:pointer;
`
export const YourPagesWrapper = styled.div`
position:relative;
width: 100%;
display:flex;
align-items: center;
background: #FFFFFF;
transition: all 0.1s ease-in-out;
overflow: hidden;
`
export const PageTogglor = styled.div`
width:60px;
height:40px;
background:#fff;
position: absolute;
`
export const PagesHeading = styled.div`
font-family: 'Lora';
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 18px;
color: #38485D;
margin-bottom:7px;
`
export const PagesList = styled.div`
display:flex;
align-items:center;
justify-content:start;
padding: 0px 10px;
overflow-y: auto;
height:100%;

  &::-webkit-scrollbar {
    width: 0.4em;
    height: 0.8em;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`
export const PagesItem = styled.div`
width: 100px;
height: 72px;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
margin-right:10px;
cursor:pointer;
border-radius: 10px;
box-shadow: 0 0 0 1px rgba(57,76,96,.15);
`
export const PagesTitle = styled.div`
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 15px;
text-align: center;
letter-spacing: 0.02em;
color: #000000;
width: 46px;
margin-top:3px;
word-wrap: break-word;
`
export const PagesImg = styled.img`
width: 30px;
height: auto;
`
export const ToolBarWrapper = styled.div`
width:100%;
display:flex;
align-items:center;
justify-content:center;
padding:5px 0px;
background: #FFFFFF;
box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`
export const ToolBarContent = styled.div`
display:flex;
align-items:center;
justify-content:start;
background: #FFFFFF;
`
export const ToolBarActions = styled.div`
margin-left:10px;
`
export const ToolBarItem = styled.div`
margin-right:10px;
cursor:pointer;
`
export const ToolBarItemBox = styled.div`
  width: 40px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 4px;
  border-radius: 25px;

  &:hover {
    div {
      background-color: rgb(217 216 217);
    }
  }
`;

export const ToolBarItemIcon = styled.div`
width:35px;
height:35px;
display:flex;
align-items:center;
justify-content:center;
cursor:pointer;

 &:hover {
      background-color: rgb(217 216 217);
  }
`;
export const FontStyleBox = styled.div`
display:flex;
align-items:center;
justify-content:center;
width:36px;
height:29px;
`
export const FontStyleIcon = styled.div`
padding:6px;
display:flex;
align-items:center;
justify-content:center;
cursor:pointer;
`
export const FontSizeBox = styled.div`
display:flex;
align-items:center;
justify-content:space-between;
border: 1px solid #cbcbd0;
border-radius: 4px;height:100%;
`
export const FontSizeInput = styled.div`
display:flex;
align-items:center;
justify-content:center;
padding:0px 5px;
background: #F7F9FF;
border: 1px solid #38485D;
width:35px;
height:34px;
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 17px;
color: #38485D;
`
export const FontSizeButton = styled.div`
display:flex;
align-items:center;
justify-content:center;
height:100%;
height:32px;
width:24px;
padding: 0px 5px;
cursor:pointer;
 &:hover {
      background-color: rgb(222 220 222 / 33%);
  }
`
export const FontStyleText = styled.div`
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 17px;
color: #38485D;
`
export const ColorPickerLabel = styled.label`
width: 43px;
height: 43px;
border: 1px solid #38485D;
border-radius: 8px;
display:block;
position:relative;
cursor:pointer;
`
export const ColorPickerInput = styled.input.attrs({
  type: 'color',
})`
position: absolute;
top: 20px;
width: 44px;
z-index: -1;
opacity:0;
`
export const LineThrough = styled.img`
width:auto;
height:13px;
margin:2px;
`
export const FullCenter = styled.div`
display:flex;
align-items:center;
justify-content:center;
height:100%;
width:100%;
`
export const PrimaryButton = styled.div`
background: #38485D;
border: 0.5px solid #38485D;
border-radius: ${props => props.borderRadius?props.borderRadius:'7px'} !important;
font-style: normal;
font-weight: 400;
font-size:${props => props.size === 'smal' ? '12px' : '14px'};
line-height: 17px;
text-align: center;
color: #FFFFFF;
padding:${props => props.size === 'smal' ? '5px 7px' : '15px 25px'};
cursor:pointer;
width:${props => props.btnWidth ? props.btnWidth : null} !important;
height:${props => props.btnHeight ? props.btnHeight : null} !important;
display:flex;
align-items:center;
justify-content:center;
`
export const SecondaryButton = styled.div`
background: #F6F9FF;
border: 1px solid #38485D;
border-radius: ${props => props.borderRadius?props.borderRadius:'7px'} !important;
ont-family: 'Montserrat';
font-style: normal;
font-weight: 400;
font-size: ${props => props.size === 'small' ? '12px' : '14px'};
line-height: 17px;
text-align: center;
color: #38485D;
padding:${props => props.size === 'small' ? '5px 7px' : '15px 25px'};
width:${props => props.btnWidth ? props.btnWidth : null} !important;
height:${props => props.btnHeight ? props.btnHeight : null} !important;
cursor:pointer;
display:flex;
align-items:center;
justify-content:center;
`

export const BlueButton= styled.div`
background: rgb(110, 195, 207);
border: 1px solid rgb(110, 195, 207);
border-radius: ${props => props.borderRadius?props.borderRadius:'7px'} !important;
ont-family: 'Montserrat';
font-style: normal;
font-weight: 400;
font-size: ${props => props.size === 'small' ? '12px' : '14px'};
line-height: 17px;
text-align: center;
color: #fff;
padding:${props => props.size === 'small' ? '5px 7px' : '15px 25px'};
width:${props => props.btnWidth ? props.btnWidth : null} !important;
height:${props => props.btnHeight ? props.btnHeight : null} !important;
cursor:pointer;
display:flex;
align-items:center;
justify-content:center;
`

export const ButtonIcon = styled.img`
width:${props => props.width} !important;
margin-right:${props => props.mr ? props.mr : null};
margin-left:${props => props.ml ? props.ml : null};
`

export const AlertTitle = styled.div`
font-style: normal;
font-weight: 400;
font-size: 22px;
line-height: 27px;
color: #000000;
`
export const AlertAsset = styled.div`
border: 2px solid #38485D;
border-radius: 5px;
padding:5px 10px;
`
export const ModalTitle = styled.div`
font-style: normal;
font-weight: 400;
font-size: 22px;
line-height: 27px;
color: #000000;
`
export const FormControl = styled.div`
margin-bottom:30px;
`
export const SearchInput = styled.input.attrs({
  type: 'text',
})`
font-size: ${props => props.small ? "13px" : "16px"};
line-height: ${props => props.small ? "17px" : "20px"};
font-weight: 400;
color:#444446;
border: 1px solid #8E8F94;
background: #FFFFFF;
background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 20 20'><path fill='%23838D99' d='M13.22 14.63a8 8 0 1 1 1.41-1.41l4.29 4.29a1 1 0 1 1-1.41 1.41l-4.29-4.29zm-.66-2.07a6 6 0 1 0-8.49-8.49 6 6 0 0 0 8.49 8.49z'></path></svg>");
background-repeat: no-repeat;
background-position: ${props => props.small ? "8px 6px" : "10px 8px"};
background-size: ${props => props.small ? "14px 14px" : "18px 18px"};
box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08);
border-radius: 7px;
width:100%;
padding:${props => props.small ? "4px 4px 4px 25px" : "6px 10px 6px 38px"};
&:placeholder{
  color: #8E8F94;
}
&:focus{
  outline: none;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.16);
}
`

export const TemplateSize = styled.div`
font-weight: 700;
font-size: 18px;
line-height: 17px;
color: #444446;
padding:5px;
margin:10px 0px;
cursor:pointer;
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
background: #e8e8e8;
border-radius: 4px;

&:hover {
  div {
    display: none;
  }

  span {
    display: block;
  }
}

span {
  display: none;
}
`
export const ResizeBoxWrapper = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
`
export const SwapBox = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
background: #EDF8FF;
border-radius: 22px;
box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.18);
`
export const SwapBoxText = styled.div`
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 14px;
display: flex;
align-items: center;
text-align: center;
color: #38485D;
padding-top:5px;
`
export const CurrentTemplateBox = styled.div`
display:flex;
flex-direction:column;
align-items:center;
justify-content:center;
padding:15px 0px;
border-top: 1px solid #38485D;
width:75%;
`
export const CurrentTemplateText = styled.div`
font-family: 'Lora';
font-style: normal;
font-weight: 700;
font-size: 11.7px;
line-height: 15px;
display: flex;
align-items: center;
color: #38485D;
padding-bottom:5px;
`
export const CurrentTemplateImg = styled.img`
width:65px;
`
export const SwapItem = styled.div`
margin-bottom:20px;
`
export const AvailableTemplateWrapper = styled.div`
height:90px;
display:flex;
align-items:center;
justify-content:center;
`
export const AvailableTemplateBox = styled.div`
background-image: url(${props => props.bgImage});
background-position: center;
background-size: cover;
background-repeat: no-repeat;
display: flex;
flex-direction: column;
-webkit-box-align: center;
align-items: center;
-webkit-box-pack: center;
justify-content: center;
padding: 7px;
width: 90px;
cursor: pointer;
height: 70px;
border-radius: 10px;
box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
`
export const AvailableTemplateImg = styled.img`
width:70px;
`
export const AvailableTemplateText = styled.div`
font-style: normal;
font-weight: 400;
font-size: 10px;
line-height: 14px;
text-align: center;
letter-spacing: 0.02em;
color: #000000;
padding-top:5px;
`
export const HelpModalIcon = styled.div`
position: absolute;
width: 90px;
background: #6EC3CF;
border-radius: 22px;
display:flex;
align-items:center;
justify-content:center;
padding:20px 0px;
top:-50px;
`
export const HelpModalTitle = styled.div`
font-family: 'Lora';
font-style: normal;
font-weight: 700;
font-size: 20px;
line-height: 26px;
display: flex;
align-items: center;
text-align: center;
color: #38485D;
margin:5px;
`
export const BodyText = styled.div`
margin-bottom:5px;
font-style: normal;
font-weight: ${props => props.fontWeignt?props.fontWeignt:'500'};
font-size: ${props =>  props.fontSize?props.fontSize:'14px'};
line-height: 20px;
display: flex;
align-items: center;
color: ${props =>  props.fontColor?props.fontColor:'#444446'};
`
export const HelpContentModal = styled.div` 
position:relative;
`
export const SelectLanguageWrapper = styled.div` 
display:flex;
flex-direction:column;
gap:10px;
padding:5px;
`
export const HelpContentLeft = styled.div`
position:absolute;
width: 60px;
height: 75px;
background: #D9D9D9;
left:-24px;
`
export const HelpContentRight = styled.div`
position:absolute;
width: 60px;
height: 75px;
background: #D9D9D9;
right:-24px;
`

export const InputText = styled.input.attrs({
  type: 'text',
})`
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 20px;
letter-spacing: 0.02em;
color: #000000;
background: #FFFFFF;
border: 1px solid #444446;
border-radius: 6px;
padding:6px 10px;
width:100%;
&:placeholder{
  color: #8E8F94;
}
&:focus{
  outline: none;
}
`
export const HelpModalLanguageBox = styled.div`
background: #EDF8FF;
padding:5px;
border-bottom: 1px solid #38485D;
margin-top:30px;
`
export const HelpModalLanguageText = styled.div`
font-family: 'Lora';
font-style: normal;
font-weight: 700;
font-size: 14px;
line-height: 18px;
display: flex;
align-items: center;
color: #38485D;
`
export const LanguageBtn = styled.div`
background: #F6F9FF;
border: 1px solid #38485D;
border-radius: 8px;
display: flex;
align-items: center;
justify-content:ceneter;
padding:5px 7px;
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 20px;
text-align: center;
color: #444446;
margin-right:5px;
`
export const HelpDividerGray = styled.div`
height: 30px;
background: #D9D9D9;
margin-bottom:5px;
`
export const LightButton = styled.div`
background: #F6F9FF;
border: 1px solid #38485D;
border-radius: 8px;
display: flex;
align-items: center;
justify-content:ceneter;
padding:5px 7px;
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 20px;
text-align: center;
color: #444446;
margin-right:5px;
`
export const Button = styled.div`
background: #F6F9FF;
border: 1px solid #38485D;
border-radius: 8px;
display: flex;
align-items: center;
justify-content:ceneter;
padding:5px 7px;
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 20px;
text-align: center;
color: #444446;
margin-right:5px;
`
export const TextSuggestionBox=styled.div`
border-left: 0.3px solid #7E9DB0;
border-right: 0.3px solid #7E9DB0;
border-bottom: 0.3px solid #7E9DB0;
`
export const SuggestedTex=styled.div`
background-color: #DEEFFA;
padding:10px;
border-top: 0.3px solid #7E9DB0;
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 15px;
display: flex;
align-items: center;
color: #38485D;
cursor:pointer;
&.active{
  background-color: #7E9DB0 !important;
  color: #fff !important;
}
`
export const LoadSuggestedTex=styled.div`
background-color: #EDF8FF;
padding:10px;
border-top: 0.3px solid #7E9DB0;
font-style: normal;
font-weight: 700;
font-size: 12px;
line-height: 15px;
display: flex;
justify-content:center;
align-items: center;
text-align: center;
color: #38485D;
cursor:pointer;
`
export const BoxDiv=styled.div`
display:block;
margin-top:${props => props.mt ? props.mt : null};
`

export const HeadingText=styled.div`
font-size: 18px;
font-weight: 700;
padding: 5pxl;
margin: 10px 0px;
`
export const SubHeadingText=styled.div`
font-size: 16px;
font-weight: 400;
padding: 5px;
margin: 10px 0px;
`
export const UploadImageButton=styled.div`
height:40px;
width:210px;
border-radius:7px;
border: 1px solid #38485D;
color: #38485D;
display: flex;
justify-content: center;
align-items: center;
gap:10px;
cursor: pointer;
margin: 10px 0px;
`
export const ControlsWrapper=styled.div`
display: flex;
justify-content: center;
align-items: center;
gap: 3px;
flex-wrap: wrap;
row-gap: 8px;
`
export const ControlItem=styled.div`
display: flex;
flex-direction: column;
justify-content: space-evenly;
align-items: center;
height: 65px;
width: 70px;
border-radius:8px;
border: 1px solid #38485D;
cursor: pointer;
`
export const ControlTitle=styled.div`
font-size:12px;
line-height:15px;
text-align:center;
color: #38485D;
user-select: none;
`
export const ResizeContainer=styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 0.5rem;
`
export const ImageAsBackground=styled.div`
display: flex;
alignItems: center;
gap: 1rem;
margin-bottom: 10px;
`
export const BlendAndOpacity=styled.div`
margin :15px 0px;
display: flex;
alignItems: center;
gap: 2rem;
`
export const BlendMode=styled.div`
display: flex;
flex-direction: column;
`
export const OpacityMode=styled.div`
display: flex;
flex-direction: column;
width:40%
`
export const SpecialEffectsWrapper=styled.div`

`
export const RedMessage=styled.div`
margin-top:20px;
color: red;
`
export const ImageViewWrapper=styled.div`
width:100%;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
cursor:pointer;
position: relative;
height: 10rem;
&:hover {
  div{
    opacity: 1;
    visibility: visible;
  }
}
`
export const InnerImageViewer=styled.div`
width:100%;
height:100%;
display:flex;
justify-content:center;
align-items:center;
cursor:pointer;
position: absolute;
top:0;
left:0;
background-color: rgba(0,0,0,.75);
opacity: 0;
visibility: hidden;
`
export const StyledSlider = styled(Slider)({
  '& .MuiSlider-rail': {
    backgroundImage: 'linear-gradient(66deg, rgba(56, 72, 93, 0.00) 10.42%, #38485D 94.79%)',
    height: 4,
    borderRadius: 2,
  },
  '& .MuiSlider-track': {
    display: 'none',
  },
  '& .MuiSlider-thumb': {
    borderRadius: '16.168px',
    background: '#FFF',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
  },
});











